import { clearGlobalMenuCache } from '@/hooks/usePortalMenu';
import { performAutoLogout, performAutoLogin } from './auth-utils';
import { NSPortalAxiosInterceptor } from './micro-frontend-interceptor';

export type { ClientToken } from './types';

export { portalAxios } from './portal-axios';

let interceptorManager: NSPortalAxiosInterceptor | undefined;

function getInterceptorManager(): NSPortalAxiosInterceptor {
  interceptorManager ??= new NSPortalAxiosInterceptor();
  return interceptorManager;
}

export const createAxiosForClient = (clientId: string) => {
  return getInterceptorManager().createClientInstance(clientId);
};

export const clearMicroFrontendTokens = () => {
  getInterceptorManager().clearAllTokens();
};

export const performManualLogout = async () => {
  getInterceptorManager().clearAllTokens();
  clearGlobalMenuCache();

  try {
    const { checkSessionValidity } = await import('./auth-utils');
    const sessionValid = await checkSessionValidity();

    if (sessionValid) {
      performAutoLogout();
    } else {
      performAutoLogin();
    }
  } catch {
    performAutoLogin();
  }
};
